import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewellNumberSelectComponent } from "./number-selector/number-select.component";
import {NewellTimePickerComponent} from "./time-picker/time-picker.component";
import { MatInputModule} from "@angular/material/input";
import { MatFormFieldModule} from "@angular/material/form-field";
import {NewellDateTimePickerComponent} from "./date-time-picker/date-time-picker.component";
import {NewellUtilityModule} from "../utility";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatButtonModule} from "@angular/material/button";


const components = [
  NewellNumberSelectComponent,
  NewellTimePickerComponent,
  NewellDateTimePickerComponent,
]

@NgModule({
  declarations: [ ...components ],
  imports: [
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatButtonModule,
    NewellUtilityModule ],
  exports: [ ...components ]
})
export class NewellFormsModule { }
